import { yaMetrikaStore } from './YaMetrikaStore';

export const useYaMetrika = () => {
  return yaMetrikaStore;
};
